const ALLOWED_IMAGE_MIME_TYPES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/gif',
]);

const ALLOWED_IMAGE_EXTENSIONS = new Set(['.jpg', '.jpeg', '.png', '.webp', '.gif']);

export const RELEASE_BANNER_IMAGE_ACCEPT = Array.from(ALLOWED_IMAGE_MIME_TYPES).join(',');

export const RELEASE_BANNER_IMAGE_VALIDATION_MESSAGE =
  'Please upload a JPEG, PNG, WebP, or GIF image. Other file types are not supported.';

const getFileExtension = (fileName: string) => {
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex < 0) {
    return '';
  }
  return fileName.slice(dotIndex).toLowerCase();
};

export const isReleaseBannerImageFile = (file: File) => {
  const mimeType = (file.type || '').toLowerCase();
  const extension = getFileExtension(file.name || '');

  const mimeAllowed = mimeType.startsWith('image/') && ALLOWED_IMAGE_MIME_TYPES.has(mimeType);
  const extensionAllowed = ALLOWED_IMAGE_EXTENSIONS.has(extension);

  return mimeAllowed || (extensionAllowed && mimeType === '');
};

export const getReleaseBannerImageValidationError = (file: File | null | undefined) => {
  if (!file) {
    return 'Please select an image file.';
  }
  if (!isReleaseBannerImageFile(file)) {
    return RELEASE_BANNER_IMAGE_VALIDATION_MESSAGE;
  }
  return null;
};
